import React, { useState } from "react";
import { getViewerContentParams, isValidBookUrl } from "./location";
import Errors from "../Errors";
import { useIntl } from "react-intl";
import ViewerProvider from "../viewer-context/ViewerProvider";
import SessionGate from "../SessionGate";
import styled from "styled-components";
import { PopoverWithSelect } from "../HighlightPopover";
import { Toast } from "../common/Toast";
import Reader from "../Reader";
import ReaderToolBar from "../ReaderToolBar";
import ExternalAPIReceiver from "./ExternalAPIReceiver";
import { TOOLBAR_HEIGHT } from "components/ReaderToolBar/consts";
import { UserProvider } from "../user-context";
import useBrandProp from "components/brand-context/useBrandProp";

const OuterContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const ToolBarContainer = styled.div`
  position: absolute;
  z-index: 1;
  width: 100%;
  pointer-events: none;
  height: ${TOOLBAR_HEIGHT}px;
`;

export default function Main() {
  const [viewer, setViewer] = useState<jigsaw.Viewer | null>(null);
  const [bookData, setBookData] = useState<jigsaw.BookData | null>(null);
  const [viewerError, setViewerError] = useState(false);
  const intl = useIntl();
  const readerToolbarEnabled = useBrandProp("ReaderToolbar.enabled");

  function viewerReady(v: jigsaw.Viewer, d: jigsaw.BookData) {
    setViewer(v);
    setBookData(d);
  }

  if (!isValidBookUrl()) {
    return <Errors />;
  }

  if (viewerError) {
    return (
      <Errors
        main={intl.formatMessage({ id: "errors.access" })}
        sub={intl.formatMessage({ id: "errors.instructor" })}
      />
    );
  }

  return (
    <>
      <ViewerProvider viewer={viewer} bookData={bookData}>
        <ExternalAPIReceiver />
        <UserProvider>
          <SessionGate>
            {/* SessionGate must be inside ViewerProvider to get logout events from jigsaw */}
            <OuterContainer>
              {readerToolbarEnabled && (
                <ToolBarContainer>
                  <ReaderToolBar />
                </ToolBarContainer>
              )}
              <Reader
                onViewerReady={viewerReady}
                onViewerError={() => setViewerError(true)}
                {...getViewerContentParams()}
              />
              <PopoverWithSelect />
            </OuterContainer>
          </SessionGate>
        </UserProvider>
      </ViewerProvider>
      <Toast />
    </>
  );
}
